import React, { useEffect, useState } from "react"
import { Button, Modal, Form, Radio, InputNumber, Alert, Space, Typography } from "antd"
import { getPaymentMelli, paymentIpgReset } from "store/actions"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { persianToEnglishNumbers } from "helpers/utilities"
const DialogBank = props => {
  const { loading, payProfit } = props

  const [openDialog, setOpenDialog] = useState(false)
  const [profit, setProfit] = useState(1000000)
  const [selectBank, setSelectBank] = useState(4)

  const handleClickOpen = () => {
    setOpenDialog(true)
  }

  const handleClose = () => {
    setOpenDialog(false)
    if (props.onPaymentMelliReset) props.onPaymentMelliReset()
  }
  function sendToBank() {
    const { onGetPaymentIpg } = props
    onGetPaymentIpg({ amount: persianToEnglishNumbers(profit.toString()) , gatewayTypeEnum: selectBank })
  }
  useEffect(() => {
    setProfit(payProfit)
  }, [payProfit])

  return (
    <div>
      <Button
        block
        className={props.classSet}
        type="default"
        onClick={handleClickOpen}
      >
        <Space>
          <span>شارژ کیف پول</span>
          <i className="mdi mdi-card-plus-outline" />
        </Space>
      </Button>

      <Modal
        title={<Typography.Text strong>شارژ کیف پول</Typography.Text>}
        open={openDialog}
        onCancel={handleClose}
        footer={null}
        destroyOnClose
      >
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          {props.error ? (
            <Alert type="error" message={props.error} showIcon />
          ) : null}

          <Form layout="vertical">
            <Form.Item label="انتخاب درگاه" style={{display:"none"}}>
              <Radio.Group
                value={selectBank}
                onChange={e => setSelectBank(e.target.value)}
              >
                <Space direction="vertical">
                  <Radio value={4}>بانک رفاه</Radio>
                  <Radio value={1} disabled>
                    بانک ملی
                  </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="مبلغ (ریال)"
              validateStatus={profit < 5000000 ? "error" : undefined}
              help={profit < 5000000 ? "مبلغ کمتر از 5 میلیون ریال مجاز نیست" : null}
            >
            <Alert style={{padding:0}}  type="info" message="حداقل مبلغ قابل شارژ 5 میلیون ریال می باشد" showIcon />
              <InputNumber
                style={{ width: "100%", marginTop: 8 }}
                value={payProfit || profit}
                min={0}
                step={1000}
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={value => (value ? value.replace(/,/g, "") : "0")}
                onChange={val => setProfit(Number(val) || 0)}
              />
            </Form.Item>

            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button onClick={handleClose}>انصراف</Button>
              <Button
                type="primary"
                onClick={sendToBank}
                loading={loading}
                disabled={profit < 5000000}
              >
                ارسال به بانک
              </Button>
            </Space>
          </Form>
        </Space>
      </Modal>
    </div>
  )
}

const mapStateToProps = ({ Payment }) => ({
  paymentMelliUrl: Payment.paymentMelliUrl,
  error: Payment.error,
  success: Payment.success,
  loading: Payment.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetPaymentIpg: data => dispatch(getPaymentMelli(data)),
  onPaymentMelliReset: () => dispatch(paymentIpgReset()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(DialogBank))
